import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 功能模块
 */
class FunctionModule extends UltMeta {
    PRODUCT_TRANSACTI0N = new Meta(1, "商品交易");
    CARG0_SHIP_MATCHING = new Meta(2, "货找船");
    QUERY_SAND_PRICE = new Meta(3, "查砂价");
    QUERY_FREIGHT_RATE = new Meta(4, "查运价");
    QUERY_SHIP = new Meta(5, "查船舶");
    QUERY_VEHICLE = new Meta(6, "查车辆");
    FIND_FUND = new Meta(7, "找资金");
    READ_NEWS = new Meta(8, "看资讯");
    CHAIN_CLOUD = new Meta(9, "链小云");
    ACTIVITY_ZONE = new Meta(10, "活动专区");
}
export const FUNCTION_MODULE = new FunctionModule();